class RefillsSelector extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const variantSelection = this.querySelector("[data-variant-selection]");
		const allVariantAsOptions = this.querySelectorAll("[variant_as_option]");

		allVariantAsOptions.forEach((el) => {
			el.addEventListener("click", (e) => {
				variantSelection.innerHTML = e.target.dataset.title;
			});
		});
	}
	disconnectedCallback() {}
}

typeof customElements.get("refills-selector") === "undefined" &&
	customElements.define("refills-selector", RefillsSelector);
